import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/ArticlePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en",
    element: <Home />,
  },
  {
    path: "/fr",
    element: <Home />,
  },
  {
    path: "/de",
    element: <Home />,
  },
  {
    path: "/da",
    element: <Home />,
  },
  {
    path: "/article/:id",
    element: <ArticlePage />,
  },
  {
    path: "/en/article/:id",
    element: <ArticlePage />,
  },
  {
    path: "/fr/article/:id",
    element: <ArticlePage />,
  },
  {
    path: "/de/article/:id",
    element: <ArticlePage />,
  },
  {
    path: "/da/article/:id",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;